module.exports = __webpack_public_path__ + "static/media/winter-sports.25e9d616.jpg";